import Service from "../../../Services/index";
import moment from "moment";

const reportSheet = {
    namespaced: true,
    state: {
        table: [],
        Form: {
            sheet_code : "",
            quantity: "",
            start_date: "",
            start_time: "",
            work_start: null,
            end_date: "",
            end_time: "",
            work_end: null,
            date: "",
            reason: "",
            machine: null,
            sheet : null,
            user:"",
            grain : null,
            grain_id : "",
            grain_new : "",
            grain_old : "",
            flour : "",
            problem: "",
            group_id : null
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_REPORT_SHEET: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        SET_REPORT_FORM: (state, res) => {
            state.Form = res;
        },
        CLEAR_FORM_DATA: state => {
            const currentDate = moment().format("YYYY-MM-DD");
            const currentTime = moment().format("HH:mm");

            state.Form = {
                sheet_code : "",
                quantity: "",
                start_date: currentDate,
                start_time: currentTime,
                work_start: null,
                end_date: "",
                end_time: null,
                work_end: null,
                date: "",
                reason: "",
                machine: null,
                sheet : null,
                user:"",
                grain : "",
                grain_id : "",
                grain_new : "",
                grain_old : "",
                flour : "",
                problem: "",
                group_id : null
            };
        }
    },
    actions: {
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        get({ commit },page=1) {
            return Service.ReportSheet.getReportSheet(page).then(response => {
                commit("GET_REPORT_SHEET", response);
            });
        },
        show({ commit }, id) {
            return Service.ReportSheet.showReportSheet(id).then(response => {
                commit("SET_REPORT_FORM", response);
            });
        },
        save({ commit, state },id) {
            const data = {
                machine_id: state.Form.machine.id,
                sheet_id :state.Form.sheet.id,
                sheet_code:state.Form.sheet.code,
                quantity: state.Form.quantity,
                start_date: state.Form.start_date,
                start_time: "",
                work_start: state.Form.work_start,
                end_date: state.Form.end_date,
                end_time: "",
                work_end: state.Form.work_end,
                reason: state.Form.reason,
                user : state.Form.user,
                grain_id : state.Form.grain_id,
                grain_new : state.Form.grain_new,
                grain_old : state.Form.grain_old,
                flour : state.Form.flour,
                problem: state.Form.problem,
                group_id : state.Form.group_id
            };
            if(!data.quantity){
                data.quantity = 0
            }
            if(data.start_date){
                data.start_time = state.Form.start_time;
            }
            if(data.end_date){
                data.end_time = state.Form.end_time;
            }
            console.log(data);
            if(!id){
                return Service.ReportSheet.createReportSheet(data)
            }else{
                return Service.ReportSheet.updateReportSheet(id, data)
            }
        },
        delete({ commit }, id) {
            return Service.ReportSheet.deleteReportSheet(id).then(() => {
                console.log("delete product success");
            });
        },
        search({ commit }, { page="",code, date, machine }) {
            return Service.ReportSheet.searchReportSheet(
                page,
                code,
                date,
                machine
            ).then(response => {
                commit("GET_REPORT_SHEET", response);
            });
        }
    }
};

export default reportSheet;
